export enum PairingStatus {
  // Important UN_PAIRED case is not returned in list API only in events
  UN_PAIRED = 'UN_PAIRED',
  IN_PAIRING = 'IN_PAIRING',
  PAIRED = 'PAIRED'
}
